/* Within Her — theme scripts: cart drawer, product form, gallery, menu */
(function () {
  'use strict';
  var WH = window.WH || {};
  var routes = WH.routes || { root: '/', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cart: '/cart' };
  var root = routes.root.replace(/\/$/, '') + '/';
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  function money(cents, trim) {
    var fmt = (WH.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var v = (cents || 0) / 100;
    var amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (trim) amount = amount.replace(/\.00$/, '');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return amount.replace('.', ',');
      return amount;
    });
  }

  /* ---------------- mobile menu ---------------- */
  function setMenu(open) {
    var nav = $('[data-wh-mobile-nav]');
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    $$('[data-wh-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  /* ---------------- cart drawer ---------------- */
  var drawer, lastFocus;
  function isCartPage() { return !!$('[data-wh-cart-page]'); }
  function openDrawer() {
    if (isCartPage()) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    drawer = drawer || $('[data-wh-drawer]');
    if (!drawer) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('[data-wh-drawer-panel]', drawer);
    setTimeout(function () { panel && panel.focus(); }, 50);
  }
  function closeDrawer() {
    drawer = drawer || $('[data-wh-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-wh-cart]', doc);
    if (!fresh) return;
    $$('[data-wh-cart]').forEach(function (el) {
      var clone = fresh.cloneNode(true);
      el.replaceWith(clone);
    });
    var count = fresh.getAttribute('data-count') || '0';
    $$('[data-wh-cart-count]').forEach(function (c) { c.textContent = count; c.setAttribute('data-count', count); });
    document.dispatchEvent(new CustomEvent('wh:cart-updated', { detail: { count: parseInt(count, 10) } }));
    var fix = fresh.getAttribute('data-gift-fix');
    if (fix && !renderCart.fixing) {
      var fp = fix.split(':');
      renderCart.fixing = true;
      post(routes.cartChange, { line: parseInt(fp[0], 10), quantity: parseInt(fp[1], 10), sections: 'cart-drawer', sections_url: window.location.pathname })
        .then(function (j) { renderCart.fixing = false; if (j && j.sections) renderCart(j.sections['cart-drawer']); })
        .catch(function () { renderCart.fixing = false; });
    }
  }

  function refreshCart() {
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data['cart-drawer']); });
  }

  function setBusy(on) { $$('[data-wh-cart]').forEach(function (c) { c.classList.toggle('is-loading', on); }); }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) { var e = new Error(j.description || j.message || 'Something went wrong'); e.data = j; throw e; }
        return j;
      });
    });
  }

  function cartAction(url, body) {
    setBusy(true);
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return post(url, body)
      .then(function (j) {
        if (j.sections && j.sections['cart-drawer']) renderCart(j.sections['cart-drawer']);
        else return refreshCart();
      })
      .catch(function (e) { alert(e.message); return refreshCart(); })
      .finally(function () { setBusy(false); });
  }

  var noteTimer;
  function saveNote(value) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post(routes.cartUpdate, { note: value }).catch(function () {}); }, 400);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-wh-menu-open]'))) { e.preventDefault(); setMenu(true); return; }
    if ((el = t.closest('[data-wh-menu-close]'))) { e.preventDefault(); setMenu(false); return; }
    if ((el = t.closest('[data-wh-cart-open]'))) {
      if (WH.cartType === 'page') return;
      e.preventDefault(); openDrawer(); return;
    }
    if ((el = t.closest('[data-wh-cart-close]'))) { e.preventDefault(); closeDrawer(); return; }
    if ((el = t.closest('[data-wh-sister]'))) {
      e.preventDefault();
      var line = parseInt(el.getAttribute('data-wh-line'), 10), giftId = el.getAttribute('data-wh-gift');
      setBusy(true);
      post(routes.cartChange, { line: line, quantity: 2 })
        .then(function () { if (giftId) return post(routes.cartAdd, { items: [{ id: parseInt(giftId, 10), quantity: 1 }] }); })
        .catch(function (err) { alert(err.message); })
        .then(refreshCart).finally(function () { setBusy(false); });
      return;
    }
    if ((el = t.closest('[data-wh-protect-off]'))) {
      e.preventDefault();
      post(routes.cartUpdate, { attributes: { _wh_no_protect: '1' } }).catch(function () {});
      cartAction(routes.cartChange, { line: parseInt(el.getAttribute('data-wh-line'), 10), quantity: 0 });
      return;
    }
    if ((el = t.closest('[data-wh-warr-off]'))) {
      e.preventDefault();
      post(routes.cartUpdate, { attributes: { _wh_no_warr: '1' } }).catch(function () {});
      cartAction(routes.cartChange, { line: parseInt(el.getAttribute('data-wh-line'), 10), quantity: 0 });
      return;
    }
    if ((el = t.closest('[data-wh-warr-on]'))) {
      e.preventDefault();
      post(routes.cartUpdate, { attributes: { _wh_no_warr: '' } }).catch(function () {});
      cartAction(routes.cartAdd, { items: [{ id: parseInt(el.getAttribute('data-wh-warr-on'), 10), quantity: 1 }] });
      return;
    }
    if ((el = t.closest('[data-wh-protect-on]'))) {
      e.preventDefault();
      post(routes.cartUpdate, { attributes: { _wh_no_protect: '' } }).catch(function () {});
      cartAction(routes.cartAdd, { items: [{ id: parseInt(el.getAttribute('data-wh-protect-on'), 10), quantity: 1 }] });
      return;
    }
    if ((el = t.closest('[data-wh-qty-set]'))) {
      e.preventDefault();
      cartAction(routes.cartChange, { line: parseInt(el.getAttribute('data-wh-line'), 10), quantity: Math.max(0, parseInt(el.getAttribute('data-wh-qty-set'), 10)) });
      return;
    }
    if ((el = t.closest('[data-wh-add]'))) {
      e.preventDefault();
      cartAction(routes.cartAdd, { items: [{ id: parseInt(el.getAttribute('data-wh-add'), 10), quantity: 1 }] });
      return;
    }
    if ((el = t.closest('[data-wh-note-toggle]'))) {
      e.preventDefault();
      var field = $('[data-wh-note-field]');
      var check = $('[data-wh-note-check]');
      var open = field.hasAttribute('hidden');
      if (open) { field.removeAttribute('hidden'); var ta = $('[data-wh-note]', field); ta && ta.focus(); }
      else { field.setAttribute('hidden', ''); var ta2 = $('[data-wh-note]', field); if (ta2) { ta2.value = ''; saveNote(''); } }
      check && check.classList.toggle('is-on', open);
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if ((el = t.closest('[data-wh-acc-btn]'))) {
      var panel = document.getElementById(el.getAttribute('aria-controls'));
      var expanded = el.getAttribute('aria-expanded') === 'true';
      el.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) { if (expanded) panel.setAttribute('hidden', ''); else panel.removeAttribute('hidden'); }
      var sign = $('.wh-acc__sign', el); if (sign) sign.textContent = expanded ? '+' : '−';
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-wh-note]')) saveNote(e.target.value);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); setMenu(false); }
  });

  /* ---------------- product page ---------------- */
  function initProduct(wrap) {
    var form = $('[data-wh-form]', wrap) || $('form[action*="/cart/add"]', wrap);
    var track = $('[data-wh-track]', wrap);
    var thumbs = $$('[data-wh-thumb]', wrap);
    var jsonEl = $('[data-wh-product-json]', wrap.parentNode);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var price = parseInt(wrap.getAttribute('data-price'), 10) || 0;
    var pct = parseInt(wrap.getAttribute('data-pct'), 10) || 0;
    var threshold = parseInt(wrap.getAttribute('data-threshold'), 10) || 0;
    var goods = parseInt(wrap.getAttribute('data-goods'), 10) || 0;
    var label = wrap.getAttribute('data-label') || 'ADD TO CART';
    var giftVariant = wrap.getAttribute('data-gift') || '';
    var giftMin = parseInt(wrap.getAttribute('data-gift-min'), 10) || 2;
    var idInput = $('[data-wh-variant-id]', wrap);
    var qtyInput = $('[data-wh-qty]', wrap);
    var submit = $('[data-wh-submit]', wrap);
    var submitLabel = $('[data-wh-submit-label]', wrap);
    var err = $('[data-wh-error]', wrap);
    var available = submit ? !submit.disabled : true;
    var set = 1;

    /* gallery */
    function goTo(i, smooth) {
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var th = thumbs[i];
      if (th && th.parentNode) {
        var p = th.parentNode;
        var left = th.offsetLeft - p.clientWidth / 2 + th.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-wh-thumb'), 10)); }); });
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
      }, { passive: true });
    }

    /* totals */
    function twoPrice() { return Math.floor(price * 2 * (100 - pct) / 100); }
    function isGiftInput(a) { return giftVariant && a.value === giftVariant && set >= giftMin; }
    function selectionTotal() {
      var total = set === 2 ? twoPrice() : price;
      $$('[data-wh-addon-input]', wrap).forEach(function (a) { if (a.checked && !isGiftInput(a)) total += parseInt(a.getAttribute('data-price'), 10) || 0; });
      return total;
    }
    function syncGiftCard() {
      $$('[data-wh-addon-input]', wrap).forEach(function (a) {
        var card = a.closest('[data-wh-addon]');
        var priceEl = $('[data-wh-addon-price]', card);
        if (priceEl && !priceEl.getAttribute('data-orig')) priceEl.setAttribute('data-orig', priceEl.textContent);
        if (giftVariant && a.value === giftVariant) {
          var free = set >= giftMin;
          if (free) { a.setAttribute('data-was', a.checked ? '1' : '0'); a.checked = true; }
          else if (a.hasAttribute('data-was')) { a.checked = a.getAttribute('data-was') === '1'; a.removeAttribute('data-was'); }
          a.disabled = free;
          card.classList.toggle('is-checked', a.checked);
          card.classList.toggle('is-free', free);
          if (priceEl) priceEl.textContent = free ? 'FREE' : priceEl.getAttribute('data-orig');
        }
      });
    }
    function update() {
      var total = selectionTotal();
      if (submitLabel) submitLabel.textContent = available ? label + ' — ' + money(total, true) : 'Coming soon';
      if (submit) submit.disabled = !available;
      var text = $('[data-wh-ship-text]', wrap), fill = $('[data-wh-ship-fill]', wrap);
      if (threshold && text) {
        var all = goods + total, left = threshold - all;
        text.textContent = goods >= threshold ? 'Your bag already ships free' : (left > 0 ? "You're " + money(left) + ' away from free shipping' : 'Add this to your bag and shipping is free');
        if (fill) fill.style.width = Math.min(100, Math.round(all / threshold * 100)) + '%';
      }
      var p1 = $('[data-wh-set1-price]', wrap), p2 = $('[data-wh-two-price]', wrap), pe = $('[data-wh-two-each]', wrap);
      if (p1) p1.textContent = money(price, true);
      if (p2) p2.textContent = money(twoPrice(), true);
      if (pe) pe.textContent = money(Math.floor(twoPrice() / 2), true);
      var pr = $('[data-wh-price]', wrap); if (pr) pr.textContent = money(price, true);
    }

    $$('[data-wh-set]', wrap).forEach(function (lab) {
      var input = $('input', lab);
      input.addEventListener('change', function () {
        set = parseInt(input.value, 10) || 1;
        $$('[data-wh-set]', wrap).forEach(function (l) { l.classList.toggle('is-active', $('input', l).checked); });
        if (qtyInput) qtyInput.value = set;
        syncGiftCard();
        update();
      });
    });
    $$('[data-wh-addon-input]', wrap).forEach(function (a) {
      a.addEventListener('change', function () { a.closest('[data-wh-addon]').classList.toggle('is-checked', a.checked); update(); });
    });

    /* variants (multi-option products) */
    var optionGroups = $$('[data-wh-option]', wrap);
    optionGroups.forEach(function (g) {
      $$('[data-wh-value]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-wh-value]', g).forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
          var lbl = $('[data-wh-option-value]', g); if (lbl) lbl.textContent = b.getAttribute('data-wh-value');
          if (!product) return;
          var chosen = optionGroups.map(function (gg) { var a = $('.is-active', gg); return a ? a.getAttribute('data-wh-value') : null; });
          var v = product.variants.find(function (vv) { return vv.options.every(function (o, i) { return o === chosen[i]; }); });
          if (!v) { available = false; update(); return; }
          idInput.value = v.id; price = v.price; available = v.available;
          if (v.featured_media && track) {
            var slide = $('[data-media-id="' + v.featured_media.id + '"]', track);
            if (slide) goTo(parseInt(slide.getAttribute('data-index'), 10));
          }
          var stockEl = $('[data-wh-stock]', wrap);
          if (stockEl) {
            var smap = {}; (stockEl.getAttribute('data-wh-stock') || '').split(',').forEach(function (pair) { var kv = pair.split(':'); if (kv.length === 2) smap[kv[0].trim()] = parseInt(kv[1], 10); });
            var n = smap[String(v.id)];
            if (typeof n === 'number' && n > 0 && n <= 10) {
              var nEl = $('[data-wh-stock-n]', stockEl), wEl = $('[data-wh-stock-w]', stockEl);
              if (nEl) nEl.textContent = n; if (wEl) wEl.textContent = n === 1 ? 'bag' : 'bags';
              stockEl.hidden = false;
            } else { stockEl.hidden = true; }
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
          update();
        });
      });
    });

    /* add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!available) return;
        if (err) { err.hidden = true; err.textContent = ''; }
        var items = [{ id: parseInt(idInput.value, 10), quantity: set }];
        var giftAdded = false;
        $$('[data-wh-addon-input]', wrap).forEach(function (a) {
          if (!a.checked) return;
          if (giftVariant && a.value === giftVariant) { if (giftAdded) return; giftAdded = true; }
          items.push({ id: parseInt(a.value, 10), quantity: 1 });
        });
        if (set >= giftMin && giftVariant && !giftAdded) items.push({ id: parseInt(giftVariant, 10), quantity: 1 });
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; })
          .then(function (c) {
            if (c && giftVariant && c.items.some(function (it) { return String(it.variant_id) === String(giftVariant); })) {
              items = items.filter(function (it) { return String(it.id) !== String(giftVariant); });
            }
            var pv = WH.protectVariant;
            if (pv && c && !(c.attributes && c.attributes._wh_no_protect) && !c.items.some(function (it) { return String(it.variant_id) === String(pv); })) {
              items.push({ id: parseInt(pv, 10), quantity: 1 });
            }
            var wv = WH.warrVariant;
            if (wv && c && !(c.attributes && c.attributes._wh_no_warr) && !c.items.some(function (it) { return String(it.variant_id) === String(wv); })) {
              items.push({ id: parseInt(wv, 10), quantity: 1 });
            }
            return post(routes.cartAdd, { items: items, sections: 'cart-drawer', sections_url: window.location.pathname });
          })
          .then(function (j) {
            if (j.sections && j.sections['cart-drawer']) renderCart(j.sections['cart-drawer']); else return refreshCart();
          })
          .then(function () {
            goods = 0;
            $$('[data-wh-addon-input]', wrap).forEach(function (a) { if (!a.disabled) { a.checked = false; a.closest('[data-wh-addon]').classList.remove('is-checked'); } });
            return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
              goods = c.total_price;
            }).catch(function () {});
          })
          .then(function () { update(); if (WH.cartType === 'page') window.location.href = routes.cart; else openDrawer(); })
          .catch(function (e2) { if (err) { err.textContent = e2.message; err.hidden = false; } })
          .finally(function () { submit.disabled = !available; submit.removeAttribute('aria-busy'); });
      });
    }

    /* sticky bar on phones */
    var sticky = $('[data-wh-sticky]', wrap.parentNode);
    if (sticky && submit && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      });
      io.observe(submit);
      var sb = $('[data-wh-sticky-btn]', sticky);
      sb && sb.addEventListener('click', function () {
        var buy = document.getElementById('buy');
        if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    syncGiftCard();
    update();
  }

  function init() {
    $$('[data-wh-product]').forEach(initProduct);
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) { $$('[data-wh-product]', e.target).forEach(initProduct); });
    }
    // keep drawer fresh when returning via back button (bfcache)
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart().catch(function () {}); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.WHCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };
})();
